import { MechanicalEstimate } from './../model/mechanicalEstimate';
import { CarServiceEstimateBuilder } from "./car-service-estimate-builder";
import * as _ from 'lodash-es';
export class MechanicalEstimateBuilder {
    static buildMechanicalEstimate(data) {
        const mechanicalEstimate = new MechanicalEstimate();
        mechanicalEstimate.id = (data.id) ? data.id : null;
        mechanicalEstimate.id_vehicle = data.id_vehicle;
        mechanicalEstimate.id_via = data.id_via;
        mechanicalEstimate.dismiss_id_via = (data.dismiss_id_via) ? data.dismiss_id_via : null;
        mechanicalEstimate.source_id_mechanical_estimate = (data.source_id_mechanical_estimate) ? data.source_id_mechanical_estimate : null;
        mechanicalEstimate.lang = data.lang;
        mechanicalEstimate.status = (data.status) ? data.status : null;
        mechanicalEstimate.date_created = (data.date_created) ? data.date_created : null;
        mechanicalEstimate.date_saved = (data.date_saved) ? data.date_saved : null;
        mechanicalEstimate.date_accepted = (data.date_accepted) ? data.date_accepted : null;
        mechanicalEstimate.date_dismissed = (data.date_dismissed) ? data.date_dismissed : null;
        mechanicalEstimate.pvp_total = data.pvp_total;
        mechanicalEstimate.base_standard = data.base_standard;
        mechanicalEstimate.vat_standard = data.vat_standard;
        mechanicalEstimate.date_last_updated = data.date_last_updated;
        mechanicalEstimate.car_service_estimates = (data.car_service_estimates) ?
            (_.map(data.car_service_estimates, (car_service_estimates) => {
                return CarServiceEstimateBuilder.buildCarServiceEstimate(car_service_estimates);
            })) : null;
        return mechanicalEstimate;
    }
}
//# sourceMappingURL=mechanical-estimate-builder.js.map